<div *ngIf="isFoerderbetrag && foerdersummeOffen && foerdersummeOffen > 0"
    class="d-flex justify-content-end align-items-center mb-2">
    <button (click)="openNewFundsPaymentDialog(null)" class="xfound-button-secondary">
        {{'payment.neuerMittelabruf' | translate}}
    </button>
</div>

<kendo-grid *ngIf="payments.length > 0" [kendoGridBinding]="payments">

    <kendo-grid-column [title]="'payment.paymentDate' | translate" field="paymentDate" [width]="120">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <div [attr.id]="'rowheader-' + rowIndex">
                {{ dataItem.paymentDate | date: translateService.GetCurrentShortDateFormat() }}
            </div>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column [title]="'payment.amount' | translate" field="amount" format="{0:c}" [width]="120">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <div [attr.aria-labelledby]="'rowheader-' + rowIndex">
                {{ formatPaymentAmount(dataItem.amount) }}
            </div>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column [title]="'payment.status' | translate" field="statusgrund" [width]="120">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <div [attr.aria-labelledby]="'rowheader-' + rowIndex">
                {{ statusgrund(dataItem.statusgrund) }}
            </div>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column [title]="'payment.mittelabruf' | translate" field="mittelabruf" [width]="120">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <div [attr.aria-labelledby]="'rowheader-' + rowIndex">
                {{ mittelabruf(dataItem.mittelabruf) }}
            </div>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column [title]="'payment.datumMittelabruf' | translate" field="datumMittelabruf" [width]="120">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <div [attr.aria-labelledby]="'rowheader-' + rowIndex">
                {{ dataItem.datumMittelabruf | date: translateService.GetCurrentShortDateFormat() }}
            </div>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column [title]="'payment.zuwendungsbestaetigung' | translate" field="zuwendungsbestaetigung" [width]="120">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <div [attr.aria-labelledby]="'rowheader-' + rowIndex">
                {{ zwb(dataItem.zuwendungsbestaetigung) }}
            </div>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column *ngIf="isZahlung" [title]="'payment.actions' | translate" [width]="200">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <button *ngIf="zahlungNichtErfolgt(dataItem.mittelabruf) && mittelAbrufbar(dataItem)" kendoGridEditCommand
                class="xfound-button-secondary" (click)="openNewFundsPaymentDialog(dataItem)"
                [attr.aria-labelledby]="'rowheader-' + rowIndex + ' action-label'">
                {{ 'payment.neuerMittelabruf' | translate }}
            </button>
        </ng-template>
    </kendo-grid-column>
</kendo-grid>